import { useTranslation } from "react-i18next";
import { Button } from "@tabipla/ui/components/button";
import { Loader2 } from "lucide-react";
import { useFollowUser, useUnfollowUser } from "../../../application/hooks/useFollow";
import { useAuth } from "../../../application/hooks/useAuth";

interface FollowButtonProps {
  userId: string;
  isFollowing: boolean;
  size?: "sm" | "default" | "lg";
}

export function FollowButton({ userId, isFollowing, size = "sm" }: FollowButtonProps) {
  const { t } = useTranslation();
  const { user } = useAuth();
  const followMutation = useFollowUser();
  const unfollowMutation = useUnfollowUser();

  // Don't show button for own profile or if not logged in
  if (!user || user.id === userId) {
    return null;
  }

  const isLoading = followMutation.isPending || unfollowMutation.isPending;

  const handleClick = () => {
    if (isFollowing) {
      unfollowMutation.mutate(userId);
    } else {
      followMutation.mutate(userId);
    }
  };

  return (
    <Button
      variant={isFollowing ? "outline" : "default"}
      size={size}
      onClick={handleClick}
      disabled={isLoading}
    >
      {isLoading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : isFollowing ? (
        t("users.unfollow")
      ) : (
        t("users.follow")
      )}
    </Button>
  );
}
